document.addEventListener("DOMContentLoaded", function () {
  const $ = window.jQuery;

  /* =========================================
     PDP TOOLTIP + BADGE INTERACTIONS (KEEP)
  ========================================== */
  const tooltipWrappers = document.querySelectorAll('.pdp-tooltip-wrapper');
  const imageWrapper = document.querySelector('.product__images');
  const badgeContainers = document.querySelectorAll('.product-badge-container');
  const badges = document.querySelectorAll('.product-badge');

  tooltipWrappers.forEach(wrapper => {
    const trigger = wrapper.querySelector('.pdp-tooltip-trigger');
    const bubble = wrapper.querySelector('.pdp-tooltip__bubble');
    const link = wrapper.querySelector('.pdp-tooltip__link');

    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (!wrapper.classList.contains('touch-active')) {
            e.preventDefault();
            tooltipWrappers.forEach(w => {
              if (w !== wrapper) w.classList.remove('touch-active');
            });
            wrapper.classList.add('touch-active');
          } else if (bubble && !bubble.contains(e.target) && link && !link.contains(e.target)) {
            wrapper.classList.remove('touch-active');
          }
        });
      }

      if (link) {
        link.addEventListener('click', function (e) {
          e.stopPropagation();
          wrapper.classList.remove('touch-active');
        });
      }

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) {
          wrapper.classList.remove('touch-active');
        }
      });
    }
  });

  badgeContainers.forEach(badge => {
    if (imageWrapper && badge) imageWrapper.appendChild(badge);
  });

  badges.forEach(function (badge) {
    badge.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      badges.forEach(b => b.classList.remove('active'));
      badge.classList.toggle('active');
    });
  });

  document.addEventListener('touchstart', function (e) {
    if (![...badges].some(b => b.contains(e.target))) {
      badges.forEach(b => b.classList.remove('active'));
    }
  });

  /* =========================================
     PDP SLIDER – COMMON IMAGE BADGE (FIXED)
     - Works even if slick initializes AFTER DOMContentLoaded
  ========================================== */
  const sliderBadge = document.querySelector('.product-common-image-badge');
  const slider = document.querySelector('.js-product__gallery');

  function updateSliderBadge() {
    if (!sliderBadge || !slider) return;

    // Slick uses .slick-current. Fallbacks for other sliders.
    const currentSlide =
      slider.querySelector('.slick-current') ||
      slider.querySelector('.is-selected') ||
      slider.querySelector('.active');

    const isCommon = !!(currentSlide && currentSlide.querySelector('.gallery-item--common'));

    // Always hide unless current slide is common
    sliderBadge.hidden = !isCommon;
  }

  if (sliderBadge) sliderBadge.hidden = true;

  // Run once now + again shortly after (covers slick init timing)
  updateSliderBadge();
  setTimeout(updateSliderBadge, 150);
  setTimeout(updateSliderBadge, 600);

  // If slick exists, bind to its event (best case)
  if ($ && slider) {
    try {
      $(slider).on('afterChange', function () {
        updateSliderBadge();
      });
      $(slider).on('init', function () {
        updateSliderBadge();
      });
    } catch (e) {}
  }

  // Always keep a MutationObserver as a fallback
  if (slider) {
    const obs = new MutationObserver(updateSliderBadge);
    obs.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  /* =========================================
     FANCYBOX / LIGHTBOX – COMMON IMAGE BADGE (FIXED)
     - Only injects if the CLICKED trigger is a common image
     - Uses Fancybox v3 correct origin: slide.opts.$orig
  ========================================== */
  if ($ && $.fancybox) {
    $(document).off('afterShow.fb.floofCommonBadge'); // prevent duplicates if theme re-inits
    $(document).on('afterShow.fb.floofCommonBadge', function (e, instance, slide) {
      // remove any badge first
      $('.fancybox-slide--current .gallery-common-image-badge').remove();

      // Fancybox v3 origin element
      const $orig = slide && slide.opts && slide.opts.$orig ? slide.opts.$orig : null;
      if (!$orig || !$orig.length) return;

      // ONLY if the clicked item is a common image
      // (this requires data-common-image="true" on gallery-item-common links)
      if (!$orig.is('[data-common-image="true"]')) return;

      const badgeHtml = `
        <div class="gallery-common-image-badge">
          Exclusive Floof Dust Bag Included
        </div>
      `;

      $('.fancybox-slide--current').append(badgeHtml);
    });
  }
});

/* =========================================
   PDP MINI CAROUSEL (below Add to Cart)
   - Sliding carousel; layout lives in assets/product.css
   - Moves slides through the --mini-carousel-offset CSS variable
   - Skips slides that are visually empty (e.g. Klarna not rendered)
   - The inline script in sections/product.liquid still sets a
     translateX on the container, which product.css neutralises
     with transform: none
========================================= */
(function () {
  function initMiniCarousel() {
    var content = document.querySelector('.pdp-mini-carousel-content');
    if (!content) return;

    var slides = Array.prototype.slice.call(content.querySelectorAll('.pdp-mini-carousel-slide'));
    if (!slides.length) return;

    var current = 0;

    // Text inside a node, ignoring <style> and <script> content
    function textOf(node) {
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
      var out = '';
      var n;
      while ((n = walker.nextNode())) {
        var tag = n.parentNode && n.parentNode.nodeName;
        if (tag !== 'STYLE' && tag !== 'SCRIPT') out += n.nodeValue;
      }
      return out.trim();
    }

    function hasContent(slide) {
      var klarna = slide.querySelector('klarna-placement');
      if (klarna) {
        if (klarna.shadowRoot) return textOf(klarna.shadowRoot).length > 0;
        return textOf(klarna).length > 0 || klarna.offsetHeight >= 16;
      }
      if (textOf(slide).length) return true;
      return Array.prototype.some.call(slide.querySelectorAll('*'), function (el) {
        return el.id !== 'klarna' && el.offsetWidth > 4 && el.offsetHeight > 4;
      });
    }

    function show(index) {
      content.style.setProperty('--mini-carousel-offset', index);
      current = index;
    }

    function next() {
      var ready = [];
      slides.forEach(function (slide, i) {
        if (hasContent(slide)) ready.push(i);
      });
      if (!ready.length) return;
      if (ready.length === 1) {
        if (current !== ready[0]) show(ready[0]);
        return;
      }
      var pos = ready.indexOf(current);
      show(ready[(pos + 1) % ready.length]);
    }

    show(0);
    setInterval(next, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMiniCarousel);
  } else {
    initMiniCarousel();
  }
})();
